import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { INivelesPromo } from './../../../../private/shared/models/productos';

interface IDiscountLevelBadge extends INivelesPromo {
  Cumple?: boolean;
}

@Component({
  selector: 'getm-discount-level-badge',
  templateUrl: './discount-level-badge.component.html',
  styleUrls: ['./discount-level-badge.component.scss'],
})
export class DiscountLevelBadgeComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() Niveles: IDiscountLevelBadge[] = [];
  @Input() level = 0;

  @ViewChild('segmentEl', { read: ElementRef }) segmentEl!: ElementRef<HTMLElement>;

  public segmentMarginLeft = 0;
  private overflowStarted = false;
  private completedLevelsAtOverflowStart = 0;

  ngOnInit() { }

  ngAfterViewInit() {
    this.calculateMarginLeft();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Niveles']) {
      requestAnimationFrame(() => this.calculateMarginLeft());
    }
  }

  private calculateMarginLeft() {
    const segment = this.segmentEl?.nativeElement;
    if (!segment) return;

    const hasOverflow = segment.scrollWidth > segment.offsetWidth;
    const completedLevels = this.Niveles.filter(n => n.Cumple).length;

    if (!this.overflowStarted && !hasOverflow) {
      this.segmentMarginLeft = 0;
      return;
    }

    if (!this.overflowStarted && hasOverflow) {
      this.overflowStarted = true;
      this.completedLevelsAtOverflowStart = completedLevels;
    }

    const completedLevelsAfterOverflow = completedLevels - this.completedLevelsAtOverflowStart;
    this.segmentMarginLeft = Math.min(0, completedLevelsAfterOverflow * -40);

  }

}
